import React from 'react';

import { UseFloatingReturn } from '@floating-ui/react-dom/src/types';

export type SetIsVisible = React.Dispatch<React.SetStateAction<boolean>>;

interface ClickProps {
  setIsVisible: SetIsVisible;
  refs: UseFloatingReturn['refs'];
}
export type HTMLElementEvent<T extends HTMLElement> = Event & {
  target: T;
  clientX: string;
  clientY: string;
};
export const useClick = ({ refs, setIsVisible }: ClickProps) => {
  const clickHandler = React.useCallback(
    (event: HTMLElementEvent<HTMLElement>) => {
      const target = event.target;
      if (!refs.reference?.current) return;
      if (
        (refs.reference.current as Element)?.contains(target) &&
        !refs.floating.current?.contains(target)
      ) {
        setIsVisible((state) => !state);
        return;
      }
      if (!refs.floating.current?.contains(target)) {
        setIsVisible(() => false);
      }
    },
    [refs.floating, refs.reference, setIsVisible]
  );
  const contextHandler = React.useCallback(() => {
    if (refs.floating?.current) {
      setIsVisible(false);
    }
  }, [refs.floating, setIsVisible]);
  const clickManager = () => {
    window.addEventListener('click', clickHandler);
    window.addEventListener('contextmenu', contextHandler);
    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsVisible(false);
    });
    return () => {
      window.removeEventListener('click', clickHandler);
      window.removeEventListener('contextmenu', contextHandler);
      window.removeEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Escape') setIsVisible(false);
      });
    };
  };
  return { clickManager };
};
